import { useState } from "react";
import axios from "axios";
import { API, formatUsd } from "../config/trading";
import { apiErrorMessage } from "../lib/errorMessage";

export function useOrderPlacement({ mode, selectedSymbol, selectedTicker, loadDashboard }) {
  const [order, setOrder] = useState({ side: "buy", order_type: "market", quantity: "0.001", price: "" });
  const [orderMessage, setOrderMessage] = useState("");

  const qty = Number(order.quantity || 0);
  const px = order.order_type === "limit" && Number(order.price) > 0 ? Number(order.price) : selectedTicker?.last || 0;
  const estimatedNotional = qty * px;

  const submitOrder = async () => {
    setOrderMessage("");
    try {
      const response = await axios.post(`${API}/orders`, {
        symbol: selectedSymbol,
        side: order.side,
        order_type: order.order_type,
        quantity: Number(order.quantity),
        price: order.order_type === "limit" ? Number(order.price) : null,
        mode,
        confirm: mode === "live",
      });
      setOrderMessage(`${response.data.side.toUpperCase()} filled at ${formatUsd(response.data.price)}.`);
      await loadDashboard();
    } catch (err) {
      setOrderMessage(apiErrorMessage(err, "Order was rejected."));
    }
  };

  const resetPaperAccount = async () => {
    try {
      const response = await axios.post(`${API}/paper/reset`);
      setOrderMessage(response.data.message || "Paper portfolio reset.");
      await loadDashboard();
    } catch (err) {
      setOrderMessage(apiErrorMessage(err, "Paper portfolio could not be reset."));
    }
  };

  return { order, setOrder, orderMessage, setOrderMessage, estimatedNotional, submitOrder, resetPaperAccount };
}